import React from 'react';

// Icons
import icon1 from '../Assets/icon/industrial (1).png';
import icon2 from '../Assets/icon/workstation.png';
import icon3 from '../Assets/icon/delivery-time.png';
import icon4 from '../Assets/icon/welding (1).png';
import icon5 from '../Assets/icon/testing.png';
import icon6 from '../Assets/icon/welding (2).png';
import icon7 from '../Assets/icon/inspection.png';
import icon8 from '../Assets/icon/sticky.png';
import icon9 from '../Assets/icon/data-leak.png';
import icon10 from '../Assets/icon/test.png';
import icon11 from '../Assets/icon/traceability.png';
import icon12 from '../Assets/icon/material-handling.png';
import icon13 from '../Assets/icon/tighten.png';

// Product Images
import img1 from '../Assets/Images/modern-technology-assembly-cars-plant-automotive-industry-shop-production-assembly-machines-top-view-process-welding-parts-car.jpg';
import img2 from '../Assets/Images/nobody-office-with-multiple-monitors-customer-service-desk-call-center-helpline-support-give-telecommunication-assistance-empty-helpdesk-with-client-telephony-reception.jpg';
import img3 from '../Assets/Images/conveyor.jpeg';
import img4 from '../Assets/Images/team-welding-robots-movement-automotive-parts-industry.jpg';
import img5 from '../Assets/Images/truck-workshop-interior-with-tools-cart-laptop-computer-diagnostics-tool-servicing-truck-vehicles.jpg';
import img6 from '../Assets/Images/production-electronic-components-high-tech-factory.jpg';
import img7 from '../Assets/Images/close-up-illuminated-machinery.jpg';
import img8 from '../Assets/Images/Screenshot 2025-06-09 173335.png';
import img9 from '../Assets/Images/composite-image-man-using-tablet-pc.jpg';
import img10 from '../Assets/Images/Screenshot 2025-06-09 173321.png';
import img11 from '../Assets/Images/Screenshot 2025-06-09 173306.png';
import img12 from '../Assets/Images/Screenshot 2025-06-09 173401.png';
import img13 from '../Assets/Images/3d-rendering-industry-40-concept.jpg';

export const ProductsComponent = () => {
  const products = [
    { name: "Automatic Assembly Lines", icon: icon1, image: img1 },
    { name: "Press Automation", icon: icon11, image: img11 },
    { name: "Conveyors", icon: icon3, image: img3 },
    { name: "Welding Cells", icon: icon4, image: img4 },
    { name: "End of Line Testing Stations", icon: icon5, image: img5 },
    { name: "Laser Welding Automation", icon: icon6, image: img6 },
    { name: "Vision Inspection", icon: icon7, image: img7 },
    { name: "Glue & Sealant Dispensing", icon: icon8, image: img8 },
    { name: "Leak Testing Applications", icon: icon9, image: img9 },
    { name: "Tightening SPM", icon: icon10, image: img10 },
    { name: "End to End Traceability Projects", icon: icon12, image: img12 },
    { name: "Material Handling Automation", icon: icon13, image: img13 },
  ];

  return (
    <div className="w-full h-full px-4 md:px-16 xl:px-24 3xl:px-36 py-[113px] max-w-[1429px] mx-auto font-roboto">
      {/* Heading */}
      <div className="text-black font-semibold text-[20px] lg:text-[20px] mb-2 text-center">
        Our Expertise Unveiled     
      </div>
      <div className="text-[#004E98] font-bold text-[48px] lg:text-[48px] mb-8 text-center">
        What Sets Us Apart
      </div>

      {/* Products Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((product, index) => (
          <div
            key={index}
            className="bg-white rounded-xl p-3 transition-all duration-300 hover:scale-[1.03] hover:shadow-lg flex flex-col justify-between h-[300px] shadow-[0_0_10px_rgba(0,0,0,0.1)]" // Added box shadow
          >
            <div className="w-full h-[280px] overflow-hidden rounded-md relative">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-cover rounded-md"
                style={{ height: '285px' }}
              />
              <div className="absolute bottom-4 left-0.5 right-0.5 bg-black bg-opacity-50 text-white text-[20px] font-bold p-3 rounded text-center">
                {product.name}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};